/* Wrapper pour lancer le parsing ENEDIS en streaming dans un Web Worker.
 * Renvoie une Promise résolue avec la map { [pdl]: résultat } et notifie la progression.
 */
export const parseEnedisFileStreaming = (file, onProgress) => {
  return new Promise((resolve, reject) => {
    let worker;
    try {
      worker = new Worker(
        new URL('../workers/enedisParser.worker.js', import.meta.url),
        { type: 'module' }
      );
    } catch (e) {
      reject(e);
      return;
    }

    worker.onmessage = (e) => {
      const { type, pct, results, message } = e.data || {};
      if (type === 'progress') {
        if (onProgress) onProgress(pct);
      } else if (type === 'done') {
        worker.terminate();
        resolve(results || {});
      } else if (type === 'error') {
        worker.terminate();
        reject(new Error(message || 'Erreur de parsing'));
      }
    };
    worker.onerror = (err) => {
      worker.terminate();
      reject(new Error(err && err.message ? err.message : 'Erreur Worker'));
    };

    worker.postMessage({ file });
  });
};
